// extracted by mini-css-extract-plugin
export var contentBlock = "content-block-module--content-block--bCvnn";
export var contentBlock_reversed = "content-block-module--content-block_reversed--Z-1mM";
export var contentBlock_alignTop = "content-block-module--content-block_align-top--ma99z";
export var contentBlock__desc = "content-block-module--content-block__desc--ScMdw";
export var contentBlock__descButton = "content-block-module--content-block__descButton--bSShe";
export var contentBlock__leftContent = "content-block-module--content-block__left-content--FIdVg";
export var contentBlock__desc_left = "content-block-module--content-block__desc_left--bvHTj";